const NON_DIGIT_REGEX = /\D/g;
const WHITESPACE_REGEX = /\s+/g;

export function extractDigits(value) {
    return String(value).replace(NON_DIGIT_REGEX, '');
}

export function normalizeWhitespace(value) {
    return String(value).replace(WHITESPACE_REGEX, ' ').trim();
}

// Tags (<h3 class="…">, <svg …><path d="…"/>) and HTML entities (&nbsp;) pass through untouched.
const MARKUP_REGEX = /(<[^>]*>|&#?\w+;)/;

/**
 * Title Case for English titles and labels ("How Much Would You Like To Borrow?").
 *
 * Only the visible text is transformed. Capitalizing whole strings used to rewrite markup too:
 * class="my-3 text-center h2" became Class="My-3 Text-Center H2" (unstyled headline), and an
 * SVG's path data had its lowercase (relative) commands turned uppercase (absolute), bending the
 * icon. A letter right after an apostrophe stays lowercase ("don't", not "Don'T").
 */
export function titleCaseText(value) {
    return String(value)
        .split(MARKUP_REGEX)
        .map(part => {
            if (MARKUP_REGEX.test(part)) {
                return part;
            }
            return part.replace(/\b[a-z]/g, (letter, offset, text) =>
                (offset > 0 && text[offset - 1] === "'") ? letter : letter.toUpperCase()
            );
        })
        .join('');
}
